/**
 * Einzelne Vorlagen-Formulakategorie
 */

import * as React from 'react';
import { IVorgangFormularKategorie, IVorgangFormulardaten } from '../../models/ApiTypes';
import VorgangFormularElement from './VorgangFormularElement';
import { Panel } from 'react-bootstrap';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { inject } from '../../utils/decorators';
import { AuftragStore } from '../../stores/AuftragStore';

export interface IVorgangFormularKategorieProps extends IVorgangFormularKategorie {
  editable?: boolean;
  formulardaten?: IVorgangFormulardaten[];
  vorgangId?: string;
  onHandleValidationStateChange?: (e: VorgangFormularKategorie) => void;
}

export interface IVorgangFormularKategorieState {
  elemente: VorgangFormularElement[];
}

@observer
export default class VorgangFormularKategorie extends React.Component<IVorgangFormularKategorieProps, IVorgangFormularKategorieState> {

  @inject(AuftragStore) auftragStore: AuftragStore;

  @observable validationstate: 'success' | 'warning' | 'error' | undefined;

  constructor(props: IVorgangFormularKategorie) {
    super(props);
    this.state = { elemente: new Array<VorgangFormularElement>() };
    this.validationstate = 'success';
    if (this.props.formular_elemente) {

      // Elemente als Objekte speichern
      this.props.formular_elemente.forEach(item => {
        const element = new VorgangFormularElement({...item, visible: (!item.abhaengigvon), vorgangId: this.props.vorgangId, onHandleChange: this.handleElementChange});
        // Wenn zu diesem Element im Vorgang bereits Daten hinterlegt wurden, diese als aktuellen Wert für Formularelement übernehmen
        if (this.props.formulardaten && this.props.formulardaten.length > 0) {
          let formulardatum = this.props.formulardaten.find((datum) => datum.elementguid === item.elementguid);
          if (formulardatum) {
            element.value = formulardatum.wert;
            if (formulardatum.wert !== null) {
              element.validationstate = 'success';
            }
          }
        }

        this.state.elemente.push(element);
      });

      // Initiale Sichtbarkeiten schalten
      this.state.elemente.forEach(item => {
          if (item.props.abhaengigvon) {
            this.state.elemente.forEach(parentItem => {
              if ((parentItem.value) && (item.props.abhaengigvon === parentItem.props.elementguid)) {
                // Die Sichtbarkeit des abhängigen Elements kann über einen festgelegten Wert geschaltet werden (z.B. Auswahl = "In Ordnung")
                // Wenn dieser nicht angegeben ist, wird über die Positiv-Auswahl der Checkbox geschaltet (wert[1])
                item.visible = ((item.props.abhaengigvon_auswahl !== null) && (item.props.abhaengigvon_auswahl !== '')) ? (parentItem.value === item.props.abhaengigvon_auswahl) : (parentItem.value === parentItem.props.werte[1]);
              }
            });
          }
      });

    }
  }

  componentDidMount() {
    // Validierbare Felder ohne vorbelegte Daten setzen Validierung der Gesamtkategorie auf negativ
    for (let element of this.state.elemente) {
      if (element.requiresValidation() && element.visible && element.value === '') {
        this.setValidationState('error');
        break;
      }
      if (element.props.typ === 'vorlage') {
        if ((element.validationstate === undefined) || (element.validationstate === 'error')) {
          this.setValidationState('error');
          break;
        }
      }
    }
  }

  @action private setValidationState(state: 'success' | 'warning' | 'error' | undefined) {
    this.validationstate = state;
    if (this.props.onHandleValidationStateChange) {
      this.props.onHandleValidationStateChange(this);
    }
  }

  @action handleElementChange = (e: VorgangFormularElement) => {
    // Elemente können innerhalb einer Kategorie andere Elemente ein-/ausblenden, z.B. wenn eine Checkbox angehakt ist
    if (this.state.elemente) {
      // Sichtbarkeit aller abhängigen Formularelemente umschalten
      this.state.elemente.forEach(
        item => { if (item.props.abhaengigvon === e.props.elementguid) {
            // Die Sichtbarkeit des abhängigen Elements kann über einen festgelegten Wert geschaltet werden (z.B. Auswahl = "In Ordnung")
            // Wenn dieser nicht angegeben ist, wird über die Positiv-Auswahl der Checkbox geschaltet (wert[1])
            item.visible = ((item.props.abhaengigvon_auswahl !== null) && (item.props.abhaengigvon_auswahl !== '')) ? (e.value === item.props.abhaengigvon_auswahl) : (e.checked);
        } }
      );
    }
    // Validierung der gesamten Kategorie
    const lastValidationState: string | undefined = this.validationstate;
    this.validationstate = 'success';
    if (this.state.elemente) {
      // Status für aktuelles Element setzen
      for (let element of this.state.elemente) {
        if (element.props.elementguid === e.props.elementguid) {
          element.validationstate = e.validationstate;
        }
      }
      // Validierung über alle Elemente der Kategorie
      for (let element of this.state.elemente) {
        if (element.visible && element.validationstate === 'error') {
          this.validationstate = 'error';
          break;
        }
      }

      // Änderung des Validierungsstatus über Callback propagieren
      if ((lastValidationState !== this.validationstate) && (this.props.onHandleValidationStateChange)) {
        this.props.onHandleValidationStateChange(this);
      }
    }
  }

  public render() {
    const { text, editable } = this.props;

    // Sichtbare Elemente für Rendern der Kategorie sammeln
    let sichtbareElemente = [];
    for (let i = 0; i < this.state.elemente.length; i++) {

      if (this.state.elemente[i].visible === true) {
        sichtbareElemente.push(
          <VorgangFormularElement
            visible={this.state.elemente[i].visible}
            key={this.state.elemente[i].props.elementguid}
            onHandleChange={this.handleElementChange}
            editable={editable}
            wert={this.state.elemente[i].value}
            vorgangId={this.state.elemente[i].props.vorgangId}
            {...this.state.elemente[i].props}/>
        );
      }
    }

    if (sichtbareElemente && sichtbareElemente.length > 0) {
      if (!text) {
        return (<div>{sichtbareElemente}</div>);
      }
      return (
        <Panel
          header={text}
          collapsible={true}
          defaultExpanded={true}
          bsStyle={this.validationstate === 'error' ? 'danger' : 'success'}
        >
          {sichtbareElemente}
        </Panel>
      );
    } else {
        // Eine Kategorie ohne Vorlage oder untergeordnete Elemente wird nicht gerendert
        return null;
    }

  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/VorgangFormularKategorie.tsx